import { useDrawerSelectors } from '@/stores/drawerStore';

/**
 * 기존 useDrawerState 훅의 호환성 래퍼
 * 새로운 Zustand store를 사용하면서 기존 인터페이스를 유지합니다.
 * 이제 drawer 상태가 새로고침 후에도 유지됩니다.
 */
export function useDrawerState() {
  return useDrawerSelectors();
}
